import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'app/components/ui/alert-dialog';
import { toast } from 'sonner';
import { useProductsSlice } from 'app/pages/Product/slice';
import { useEffect } from 'react';

interface Props {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  data: { id: string | number | null };
}

export function AlertProductAttributeDelete({
  isOpen,
  onOpenChange,
  data,
}: Props) {
  const { useDeleteProductsAttributeTypeMutation } = useProductsSlice();

  const [
    deleteTags,
    { isLoading: isDeleting, error: deleteError, data: deletedData },
  ] = useDeleteProductsAttributeTypeMutation();

  const handleDelete = () => {
    deleteTags(data?.id);
  };

  useEffect(() => {
    if (deleteError) {
      toast.error(deleteError?.message || 'An error occurred');
    }
  }, [deleteError]);

  useEffect(() => {
    if (deletedData) {
      toast.success(deletedData?.message || 'Tag deleted successfully');
      onOpenChange(false);
    }
  }, [deletedData]);

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} disabled={isDeleting}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
